// MapContext.jsx
import { createContext, useContext, useState } from "react";

const MapContext = createContext();

export const MapProvider = ({ children }) => {
  const [showClusterer, setShowClusterer] = useState(true);

  const toggleClusterer = () => {
    setShowClusterer((prev) => !prev);
  };

  return (
    <MapContext.Provider value={{ showClusterer, toggleClusterer }}>
      {children}
    </MapContext.Provider>
  );
};

export const useMap = () => useContext(MapContext);
